import { render, staticRenderFns } from "./CardBody.vue?vue&type=template&id=052bf2b4&scoped=true&"
import script from "./CardBody.vue?vue&type=script&lang=js&"
export * from "./CardBody.vue?vue&type=script&lang=js&"
import style0 from "./CardBody.vue?vue&type=style&index=0&id=052bf2b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052bf2b4",
  null
  
)

export default component.exports